import { useCallback } from "react";
import type {
  EventTransformerHooks,
  UseInstantTransformEvent,
} from "@b2bportal/core-tracking";
import {
  CheckoutRawEventName,
  CheckoutEventName,
  type CheckoutHTSEvent,
  type CheckoutRawEvent,
  type AddContactInformationHTSEvent,
  type SubmitContactInformationButtonClickedRawEvent,
} from "./types";

export const useCheckoutSubmitContactInformationButtonClickedTransformer: UseInstantTransformEvent<
  SubmitContactInformationButtonClickedRawEvent,
  AddContactInformationHTSEvent
> = () => {
  return useCallback((_event) => {
    return {
      name: CheckoutEventName.add_contact_info,
      properties: {},
    };
  }, []);
};
export const CHECKOUT_HTS_EVENT_TRANSFORMER_HOOKS: EventTransformerHooks<
  CheckoutRawEvent,
  CheckoutHTSEvent
> = {
  [CheckoutRawEventName.SubmitContactInformationButtonClicked]: [
    useCheckoutSubmitContactInformationButtonClickedTransformer,
  ],
};
